import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';
import Flag from '../../../images/illustrations/Illu-pastille-flag.png';
import Landcape from '../../../images/illustrations/landscape.svg';
import Line from '../../../images/illustrations/line.svg';
import ImageTexture from '../../../images/textures/texture-green.png';
import {
  AsideColumn,
  Container as LayoutContainer,
  FullColumn,
  MainColumn,
} from '../../../Layout';

const Container = styled(LayoutContainer)`
  ${tw`relative lg:pt-huge`}

  @media (max-width: 992px) {
    ${tw`px-0`}
  }

  background: url(${ImageTexture}),
    linear-gradient(97.78deg, #f5f4ec 0.37%, #edfdf9 92.55%);
`;

const LineImage = styled.img`
  ${tw`hidden lg:block lg:absolute`}
  width: 217px;
  height: 164px;
  left: -31px;
  top: -40px;
  transform: rotate(94deg);
`;

const LandcapeContainer = styled.div`
  ${tw`absolute hidden lg:block`}

  right: 0;
  bottom: 0;
`;

const LandcapeWrapper = styled.div`
  ${tw`relative`}
`;

const FlagImage = styled.img`
  ${tw`absolute`}
  width: 122px;
  height: 122px;

  left: -60px;
  top: -32px;
`;

const WrapperStyle = css`
  ${tw`bg-primary-400 
    lg:z-1 lg:rounded-tr-30 lg:rounded-tl-30
`}

  padding-top: env(safe-area-inset-top);

  @media (min-width: 992px) {
    min-height: 149px;
  }
`;

export const MainContentWrapper = styled(MainColumn)`
  ${WrapperStyle}
  ${tw`
    lg:rounded-tr-none 
  `}

  @media (min-width: 992px) {
    margin-left: calc(var(--size-medium2) * -1);
  }
`;

export const AsideContentWrapper = styled(AsideColumn)`
  ${WrapperStyle}
  ${tw`relative lg:rounded-tl-none`}

  @media (min-width: 992px) {
    margin-left: calc(var(--size-medium2) * -1);
    margin-right: calc(var(--size-medium2) * -1);
  }
`;

export const FullContentWrapper = styled(FullColumn)`
  ${WrapperStyle}

  @media (min-width: 992px) {
    margin-left: calc(var(--size-medium2) * -1);
    margin-right: calc(var(--size-medium2) * -1);
  }
`;

/**
 * @description Returns the header common to all funnel steps
 * @note This component uses the Container component of the /src/layout file. In order to place elements correctly when using it, it is advisable to use the /src/layout file's positioning components as well.
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
const FunnelHeader = ({
  children,
  withFlag,
}: {
  children: React.ReactNode;
  withFlag?: boolean;
}) => (
  <Container>
    <LineImage alt="Line" loading="lazy" src={Line} />

    <LandcapeContainer>
      <LandcapeWrapper>
        <img alt="Landscape" loading="lazy" src={Landcape} />
        {withFlag ? <FlagImage alt="Flag" loading="lazy" src={Flag} /> : null}
      </LandcapeWrapper>
    </LandcapeContainer>

    {children}
  </Container>
);

export default FunnelHeader;
